import React from 'react';
import { st, classes } from './PulseAnimation.st.css';
import Animate from '../Animate';
import { CHILD_SIZE, CHILD_WIDTH_RANGE } from './PulseAnimation.constants';
import { isValueInRange } from '../Animate/utils';
import {
  PulseAnimationProps,
  PulseAnimationSize,
  PulseAnimationState,
} from './PulseAnimation.types';

/** PulseAnimation*/
class PulseAnimation extends React.PureComponent<
  PulseAnimationProps,
  PulseAnimationState
> {
  static displayName = 'PulseAnimation';

  static defaultProps = {
    loop: true,
    fluid: false,
  };

  rootRef = React.createRef<HTMLDivElement>();

  constructor(props: PulseAnimationProps) {
    super(props);

    this.state = {
      animationSize: undefined,
    };
  }

  componentDidMount() {
    const animationSize = this._getAnimationSize();
    this.setState({ animationSize });
  }

  _getAnimationSize = (): PulseAnimationSize => {
    const childWidth = this.rootRef.current?.offsetWidth ?? 0;
    const { from, to } = CHILD_WIDTH_RANGE.medium;

    return isValueInRange(childWidth, from, to)
      ? CHILD_SIZE.medium
      : CHILD_SIZE.small;
  };

  render() {
    const {
      dataHook,
      active,
      onEnd,
      onStart,
      loop,
      children,
      delay,
      color,
      borderRadius,
      fluid,
    } = this.props;

    const { animationSize } = this.state;

    return (
      <Animate
        dataHook={dataHook}
        animateClasses={st(classes.root, {
          active,
          loop,
          size: animationSize,
          fluid,
          color,
        })}
        animateInlineStyle={{ borderRadius }}
        onEnd={onEnd}
        onStart={onStart}
        delay={delay}
        ref={this.rootRef}
      >
        {children}
      </Animate>
    );
  }
}

export default PulseAnimation;
